var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.945,
    height: 17.896,
    viewBox: "0 0 17.945 17.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34935",
    "data-name": "Path 34935",
    d: "M124.148,102.733a1.461,1.461,0,0,0-2.066-.007l-6.479,6.437-6.482-6.482a1.461,1.461,0,0,0-2.066,2.066l6.476,6.476-6.424,6.382a1.461,1.461,0,0,0,2.059,2.072l6.43-6.389,6.434,6.434a1.461,1.461,0,1,0,2.066-2.066l-6.427-6.427,6.473-6.43A1.461,1.461,0,0,0,124.148,102.733Z",
    transform: "translate(-106.628 -102.254)",
    fill: "#bfbfbf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/xIcon.35d05392.svg";
export { ForwardRef as ReactComponent };